import React, { useEffect, useState } from 'react';
import Header from 'component/layout/header/Header';
import styles from './DocsPage.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import { useBrandingContext } from 'app-context/BrandingsContext';
import { documentation } from 'hooks/endpoints';
import { useFetch } from 'hooks/useFetch';
import Loader from 'component/atom/loader/Loader';

const DocsPage = () => {
  const { brandingData } = useBrandingContext();

  const [activeIndexes, setActiveIndexes] = useState([]);
  const [activeContent, setActiveContent] = useState(null);
  const { data: docsData, isFetching } = useFetch(
    ['documentation'],
    documentation?.getDocs
  );

  const toggleSection = (index) => {
    if (activeIndexes.includes(index)) {
      setActiveIndexes(activeIndexes.filter((i) => i !== index));
    } else {
      setActiveIndexes([...activeIndexes, index]);
    }
  };

  const svgTypes = ['star', 'rocket', 'document'];

  useEffect(() => {
    if (
      docsData?.data?.length &&
      activeIndexes.length === 0 &&
      !activeContent
    ) {
      const firstSection = docsData.data[0];
      const firstItem = firstSection?.details?.[0];

      if (firstItem) {
        setActiveIndexes([0]);
        setActiveContent(firstItem);
      }
    }
  }, [docsData]);

  return (
    <div className={styles['docs-container']}>
      <Header title="Docs" />
      {isFetching ? <Loader backdrop /> : null}
      <div className={styles['docs-layout']}>
        <div className={styles['side-selection']}>
          {docsData?.data?.map((section, index) => {
            const isOpen = activeIndexes.includes(index);
            return (
              <div className={styles['toggler-container']} key={index}>
                <div
                  className={styles['header']}
                  onClick={() => toggleSection(index)}
                >
                  <div className={styles['header-text']}>
                    <SvgWithBranding
                      type={svgTypes[index] || 'document'}
                      className={styles.icon}
                    />
                    <p>{section.header}</p>
                  </div>
                  <SvgWithBranding
                    type="arrow"
                    className={`${styles['arrow']} ${
                      isOpen ? styles['rotated'] : ''
                    }`}
                  />
                </div>
                <div
                  className={`${styles['content']} ${
                    isOpen ? styles['open'] : styles['closed']
                  }`}
                >
                  {isOpen &&
                    Array.isArray(section.details) &&
                    section.details.map((item, subIndex) => (
                      <p
                        key={subIndex}
                        className={`${styles['content-item']} ${
                          activeContent?.id === item.id ? styles['active'] : ''
                        }`}
                        style={{
                          background:
                            activeContent?.id === item.id
                              ? brandingData.page_ButtonColor
                              : '',
                          color: activeContent?.id === item.id ? 'white' : '',
                        }}
                        onClick={() => setActiveContent(item)}
                      >
                        {item.header}
                      </p>
                    ))}
                </div>
              </div>
            );
          })}
        </div>

        <div className={styles['docs-contents']}>
          {activeContent ? (
            <div className={styles['content-body']}>
              <h3>{activeContent.label}</h3>
              <p>{activeContent.innerContent}</p>
            </div>
          ) : null}
        </div>

        <div className={styles['table-of-content']}></div>
      </div>
    </div>
  );
};

export default DocsPage;
